import GridSaveManager from "./GridSaveManager";
import GridSaveMeta from "./GridSaveMeta";

export default class GridSaveManagerSave {
    constructor() {
    }

    /**
     * @param {GridSaveManager} gridSaveManager 
     * @returns {Object}
     */
    static generateSave(gridSaveManager) {
        const saveState = {};

        saveState.metaArray = [];

        for (const gridMeta of gridSaveManager.metadataByKey.values()) {
            const metaState = this.generateMetaState(gridMeta);
            if (metaState) {
                saveState.metaArray.push(metaState);
            }
        }

        return saveState;
    }

    /**
     * @param {GridSaveManager} gridSaveManager 
     * @param {Object} saveState 
     */
    static loadSave(gridSaveManager, saveState) {
        if (!saveState) {
            console.log('GridSaveManagerSave.loadSave() no data found in save 1');
            return;
        }

        const metaArray = saveState.metaArray;
        if (!metaArray || metaArray.length === 0) {
            console.log('GridSaveManagerSave.loadSave() no data found in save 2');
            return;
        }

        for (let i = 0; i < metaArray.length; i++) {
            const gridSaveMeta = this.loadMetaState(metaArray[i]);
            if (gridSaveMeta) {
                gridSaveManager.addGridSaveMetaFromSave(gridSaveMeta);
            }
        }
    }

    /**
     * @private
     * @param {GridSaveMeta} gridMeta 
     * @returns {Object}
     */
    static generateMetaState(gridMeta) {
        const metaState = {};

        metaState.k = gridMeta.gridKey;
        metaState.c = gridMeta.gridCol;
        metaState.r = gridMeta.gridRow;

        return metaState;
    }    

    /**
     * @private
     * @param {Object} metaState 
     * @returns {GridSaveMeta}
     */
    static loadMetaState(metaState) {
        if (!metaState) {
            return null;
        }

        return new GridSaveMeta(metaState.k, metaState.c, metaState.r);
    }

}